import axios from "axios";

const SERVER = process.env.REACT_APP_SERVER_DOMAIN || "http://localhost:8000";

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

/**
 * GET /api/integrations/facebook/login — asks the backend to build the
 * Facebook authorization URL. The frontend never constructs OAuth URLs itself.
 * @returns {Promise<string>} authorizationUrl
 */
export async function fetchFacebookAuthorizationUrl(workspaceId, token) {
  const response = await axios.get(`${SERVER}/api/integrations/facebook/login`, {
    params: { workspaceId },
    headers: authHeaders(token),
  });
  return response.data?.data?.authorizationUrl;
}

/**
 * GET /api/integrations/facebook/pending-pages — the Pages (id + name) the user
 * can pick from after authorizing more than one.
 * @returns {Promise<Array<{id: string, name: string}>>}
 */
export async function fetchPendingFacebookPages(selection, token) {
  const response = await axios.get(`${SERVER}/api/integrations/facebook/pending-pages`, {
    params: { selection },
    headers: authHeaders(token),
  });
  return response.data?.data?.pages || [];
}

/** POST /api/integrations/facebook/select-page — connects the chosen Page. */
export async function selectFacebookPage(selection, pageId, token) {
  await axios.post(
    `${SERVER}/api/integrations/facebook/select-page`,
    { selection, pageId },
    { headers: authHeaders(token) }
  );
}

/**
 * POST /api/integrations/facebook/disconnect — removes the workspace's Facebook connection.
 */
export async function disconnectFacebook(workspaceId, token) {
  const response = await axios.post(
    `${SERVER}/api/integrations/facebook/disconnect`,
    { workspaceId },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}
